import { CompanyRespWithSettingAttributes } from '~src/interfaces/company.interface';
import { SystemLocalesI } from '~src/interfaces/session.types';

export enum SegmentType {
  Company = 'company',
  User = 'user',
  Group = 'group',
  Team = 'team',
  Admins = 'admin',
  Anonymous = 'anonymous',
}

export interface SegmentBase {
  id: string;
  image_url: string;
  deactivated?: boolean;
  user_count?: number;
}

export interface CompanySegment extends SegmentBase {
  type: SegmentType.Company;
  meta: {
    name: string;
  };
}

export interface AdminSegment extends SegmentBase {
  type: SegmentType.Admins;
  meta: {
    name: string;
  };
}

export interface GroupSegment extends SegmentBase {
  type: SegmentType.Group;
  meta: {
    option_name: SystemLocalesI;
    attribute_name: SystemLocalesI;
  };
}

export interface UserSegment extends SegmentBase {
  type: SegmentType.User;
  meta: {
    email: string;
    firstname: string;
    lastname: string;
    manager_uuid: string | null;
    name: string;
  };
}

export const isUserSegment = (seg: Segment): seg is UserSegment => seg.type === SegmentType.User;

export interface TeamSegment extends SegmentBase {
  type: SegmentType.Team;
  meta: {
    manager_name: string;
    manager_email: string;
    manager_uuid: string;
  };
}

export interface AnonymousSegment extends SegmentBase {
  type: SegmentType.Anonymous;
}

export function getAnonymousSegment(): AnonymousSegment {
  return {
    type: SegmentType.Anonymous,
    id: '',
    image_url: '',
  };
}

export function getCompanySegment(company: CompanyRespWithSettingAttributes): CompanySegment {
  return {
    meta: {
      name: company.name,
    },
    id: company.uuid,
    image_url: company.imageUrl || '',
    type: SegmentType.Company,
    deactivated: false,
  };
}

export function segmentEquals(a: Segment, b: Segment): boolean {
  return a.type === b.type && a.id === b.id;
}

export function getEmptyCompanySegment(companyLabel = '?'): CompanySegment {
  return {
    type: SegmentType.Company,
    meta: {
      name: companyLabel,
    },
    id: '',
    image_url: '',
  };
}

export type Segment = CompanySegment | GroupSegment | UserSegment | TeamSegment | AnonymousSegment| AdminSegment;
